/* CARBO V5: Kein zweiter Cart-Request, sondern ein nativer Shopify-Klick.
   Leiste sichtbar nur mobil nach Vorbeiscrollen am Original-Kaufbutton. */
(() => {
  'use strict';
  const mq = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('[data-tp-mobile-sticky]').forEach((bar) => {
    if (bar.dataset.tpStickyReady === 'true') return;
    bar.dataset.tpStickyReady = 'true';
    const scope = bar.closest('.product-information');
    const action = bar.querySelector('[data-tp-sticky-submit]');
    const title = bar.querySelector('[data-tp-sticky-title]');
    const price = bar.querySelector('[data-tp-sticky-price]');
    const variants = Array.from(bar.querySelectorAll('[data-tp-sticky-variant]')).map((node) => ({
      id:node.dataset.id,title:node.dataset.title,price:node.dataset.price,available:node.dataset.available==='true'
    }));
    if (!scope || !action || !variants.length) return;
    const original = () => scope.querySelector('product-form-component button[name="add"][type="submit"]');
    const current = () => {
      const radio = scope.querySelector('.tp-nuggets-variants input[type="radio"]:checked');
      if (radio) {
        const match = variants.find(x => x.title===radio.value);
        if (match) return match;
      }
      const id = scope.querySelector('product-form-component form[action*="/cart/add"] input[name="id"]')?.value;
      return variants.find(x => x.id===id) || variants[0];
    };
    let queued=false;
    function refresh() {
      queued=false;
      const native=original(), variant=current();
      const disabled=!native||native.disabled||native.getAttribute('aria-disabled')==='true'||!variant?.available;
      title.textContent=variant ? variant.title+' '+bar.dataset.tpProduct : bar.dataset.tpProduct;
      price.textContent=variant ? variant.price+' · Transportbox inklusive' : '';
      action.disabled=disabled;
      const modalOpen=!!document.querySelector('dialog[open],[role="dialog"][aria-modal="true"]');
      const afterOriginal=!!native && native.getBoundingClientRect().bottom<10;
      bar.hidden=!(mq.matches&&afterOriginal&&!disabled&&!modalOpen);
    }
    function update() { if(queued)return;queued=true;requestAnimationFrame(refresh); }
    action.addEventListener('click', () => {
      const native=original();
      if(native&&!native.disabled){native.click();update();}
    });
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if(mq.addEventListener)mq.addEventListener('change',update);
    else mq.addListener(update);
    ['change','input','variant:update','variant:change','product:variant-change'].forEach(name=>document.addEventListener(name,update,true));
    document.addEventListener('shopify:section:load',update);
    document.addEventListener('click',update,true);
    const native=original();
    if(native&&typeof MutationObserver!=='undefined'){
      new MutationObserver(update).observe(native,{attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    }
    refresh();
  });
})();
